import { render, staticRenderFns } from "./DocumentCreate.vue?vue&type=template&id=540a1d0c&scoped=true"
import script from "./DocumentCreate.vue?vue&type=script&lang=js"
export * from "./DocumentCreate.vue?vue&type=script&lang=js"
import style0 from "./DocumentCreate.vue?vue&type=style&index=0&id=540a1d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a1d0c",
  null
  
)

export default component.exports